/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { WebhookEventsResponse } from '../models';
/**
 * WebhookEventsApi - axios parameter creator
 * @export
 */
export const WebhookEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all supported webhook events with descriptions for Partner UI webhook event subscription
         * @summary Get supported webhook events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedWebhookEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhook-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookEventsApi - functional programming interface
 * @export
 */
export const WebhookEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all supported webhook events with descriptions for Partner UI webhook event subscription
         * @summary Get supported webhook events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedWebhookEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedWebhookEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookEventsApi.getSupportedWebhookEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhookEventsApi - factory interface
 * @export
 */
export const WebhookEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookEventsApiFp(configuration)
    return {
        /**
         * Retrieve all supported webhook events with descriptions for Partner UI webhook event subscription
         * @summary Get supported webhook events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedWebhookEvents(options?: RawAxiosRequestConfig): AxiosPromise<WebhookEventsResponse> {
            return localVarFp.getSupportedWebhookEvents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookEventsApi - object-oriented interface
 * @export
 * @class WebhookEventsApi
 * @extends {BaseAPI}
 */
export class WebhookEventsApi extends BaseAPI {
    /**
     * Retrieve all supported webhook events with descriptions for Partner UI webhook event subscription
     * @summary Get supported webhook events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookEventsApi
     */
    public getSupportedWebhookEvents(options?: RawAxiosRequestConfig) {
        return WebhookEventsApiFp(this.configuration).getSupportedWebhookEvents(options).then((request) => request(this.axios, this.basePath));
    }
}

